import { Reveal } from "@/lib/motion";
import { Activity, Radar, Sparkles } from "lucide-react";

const DASH_IMG = "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const CHIP_IMG =
  "https://static.prod-images.emergentagent.com/jobs/21f7c395-9e08-413f-97be-298a12588442/images/ad8da62137ada2c21937c4bf8572223c2bd757a677e14d0b02989d5e90db17d8.jpeg";

const FEATURES = [
  { icon: Radar, title: "Signal capture", body: "Auto-ingests calls, mail and product usage into one deal timeline." },
  { icon: Activity, title: "Live forecasting", body: "Confidence-scored projections that recalc on every new signal." },
  { icon: Sparkles, title: "Next best move", body: "One prioritized action per deal — no more staring at a dashboard." },
];

export const Showcase = () => {
  return (
    <section id="showcase" data-testid="showcase-section" className="py-28 md:py-40 bg-ink-2 border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Clipped product frame with spotlight */}
          <Reveal className="lg:col-span-7" y={60}>
            <div className="relative group">
              <div className="absolute -inset-x-8 -top-8 h-40 spotlight pointer-events-none" />
              <div className="relative overflow-hidden rounded-[3px] border border-white/10">
                <img
                  src={DASH_IMG}
                  alt="AXIOM dashboard"
                  className="w-full h-[300px] md:h-[440px] object-cover grayscale-[0.2] group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-1000 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-ink/70 via-transparent to-transparent" />
                <div className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-acid">
                  ● Forecast v4 — running
                </div>
              </div>
              <img
                src={CHIP_IMG}
                alt="AXIOM core module"
                className="hidden md:block absolute -bottom-10 -right-8 w-40 h-40 object-cover rounded-[3px] border border-white/15 shadow-2xl shadow-black/60 rotate-3"
              />
            </div>
          </Reveal>

          {/* Copy + features */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">
                The platform
              </span>
              <h2 className="mt-4 font-display font-bold text-3xl md:text-5xl tracking-tight leading-[1.02] text-paper">
                One surface. Every <span className="font-serif-i italic font-normal text-acid">decision</span>.
              </h2>
            </Reveal>

            <div className="mt-10 space-y-8">
              {FEATURES.map((f, i) => (
                <Reveal key={f.title} delay={i * 0.08}>
                  <div className="flex gap-4 group">
                    <div className="mt-1 w-10 h-10 shrink-0 rounded-full border border-white/15 flex items-center justify-center group-hover:border-acid group-hover:bg-acid/10 transition-colors">
                      <f.icon className="w-4 h-4 text-acid" />
                    </div>
                    <div>
                      <h3 className="font-display font-semibold text-lg text-paper">{f.title}</h3>
                      <p className="text-paper/55 leading-relaxed mt-1">{f.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
